export const privacyData = [
    {
      title: "Introduction",
      detail: `We, at 'Unifycare' and our affiliated companies worldwide, are
      committed to respecting your online privacy and recognize your need
      for appropriate protection and management of any personally
      identifiable information ('Personal Information') you share with us.
      In order to provide a personalised browsing experience, unify.care
      may collect information from you, this may include technical or
      other related information from the device used to access unify.care
      including without limitation contact lists in your device and its
      location, you may also be asked to complete a registration form.
      When you let us have your preferences, we will be able to deliver or
      allow you to access the most relevant information that meets your
      end.'Personal Information' means any information that may be used to
      identify an individual, including, but not limited to, a first and
      last name, a home or other physical address and an email address or
      other contact information, whether at work or at home. In general,
      you can visit Unifycare's web pages without telling us who you are
      or revealing any Personal Information about yourself.`
    },
    {
      title: "Cookies and Other Tracking Technologies",
      detail: `Some of our web pages utilize 'cookie' and other tracking
      technologies. A 'cookie' is a small text file that may be used, for
      example, to collect information about activity on the web site. Some
      cookies and other technologies may serve to recall Personal
      Information previously indicated by a Web user. Most browsers allow
      you to control cookies, including whether or not to accept them and
      how to remove them. You may set most browsers to notify you if you
      receive a cookie, or you may choose to block cookies with your
      browser, but please note that if you choose to erase or block your
      cookies, you will need to re-enter your original user ID and
      password to gain access to certain parts of the web site. Tracking
      technologies may record information such as internet domain and host
      names; internet protocol (IP) addresses; browser software and
      operating system types; clickstream patterns; and dates and times
      that our site is accessed. Our use of cookies and other tracking
      technologies allows us to improve our web site and your web
      experience. We may also analyze information that does not contain
      Personal Information for trends and statistics.`
    },
    {
      title: "Third Party Services",
      detail: `Third parties provide certain services available on www.unify.care
      on behalf of 'Unify Digital LLP”. 'Unify Digital LLP' may provide
      information, including Personal Information, that 'Unify Digital
      LLP' collects on the web to third-party service providers to help us
      deliver programs, products, information, and services. Service
      providers are also an important means by which 'Unify Digital LLP'
      maintains its web sites and mailing lists. 'Unify Digital LLP' will
      take reasonable steps to ensure that these third-party service
      providers are obligated to protect Personal Information on Unify
      Digital LLP behalf. 'Unify Digital LLP' does not intend to transfer
      Personal Information without your consent to third parties who are
      not bound to act on Unify Digital LLP behalf unless such transfer is
      legally required. Similarly, it is against Unify Digital LLP policy
      to sell Personal Information collected online without consent.`
    },
    {
      title: "Your Consent",
      detail: `By using this web site, you consent to the terms of our online
      Privacy Policy and to Unify Digital LLP's processing of Personal
      Information for the purposes given above...`
    },
    {
      title: "Information Security",
      detail: `We take appropriate security measures to protect against
      unauthorized access to or unauthorized alteration, disclosure or
      destruction of data.`
    },
    {
      title: "Updating Your Information",
      detail: `We provide mechanisms for updating and correcting your personally
      identifying information for many of our services. For more
      information, please see the help pages for each service.`
    },
    {
      title: "Children",
      detail: `Unify Digital LLP will not contact children under age 13 about
      special offers or for marketing purposes without a parent's
      permission.`
    },
    {
      title: "Confidentiality and Security",
      detail: `We have physical, electronic, and procedural safeguards that comply
      with the laws prevalent in India to protect personal information
      about you. We seek to ensure compliance with the requirements of the
      Information Technology Act, 2000 as amended and rules made
      thereunder to ensure the protection and preservation of your
      privacy.`
    },
    {
      title: "Changes to this Privacy Policy",
      detail: `Unify Digital LLP reserves the right to update, change or modify
      this policy at any time. The policy shall come to effect from the
      date of such update, change or modification.`
    },
    {
      title: "Disclaimer",
      detail: `Unify Digital LLP uses the maximum care as is possible to ensure
      that all or any data / information in respect of electronic transfer
      of money does not fall in the wrong hands. For completing online
      transactions involving payments a user is directed to a secured
      payment gateway, Unify Digital LLP does not store or keep financial
      data such as credit card numbers/passwords/PINs etc "Personal
      Account Related Information". Since the transaction happens on a
      third party network not controlled by Unify Digital LLP, once an
      online transaction has been completed, the Personal Account Related
      Information is not accessible to anyone at Unify Digital LLP after
      completion of the on-line transaction at the payment gateway, this
      ensures maximum security.`
    },
    {
      title: "Contact Information",
      detail: `Unify Digital LLP welcomes your comments regarding this privacy
      statement at the contact address given at the website. Should there
      be any concerns about contravention of this Privacy Policy, Unify
      Digital LLP will employ all commercially reasonable efforts to
      address the same.`
    },
    {
      title: "Note",
      detail: `The terms in this agreement may be changed by Unify Digital LLP at
      any time. Unify Digital LLP is free to offer its services to any
      client/prospective client without restriction.`
    }
  ];